module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPC ? 'start' : 'start-mobile',
    attrs: {
      "id": "start"
    }
  }, [(_vm.isPC) ? _c('Icon') : _vm._e(), _vm._v(" "), _c('Shadows', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPC && _vm.isWX),
      expression: "!isPC && isWX"
    }]
  }), _vm._v(" "), (!_vm.isPC) ? _c('Top') : _vm._e(), _vm._v(" "), _c('Titles'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Inputs', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "type": 'inviteAccount'
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    style: ({
      marginBottom: (_vm.isPC ? '100px' : '0px')
    }),
    attrs: {
      "type": 'StartSecureMessaging',
      "data": _vm.account
    },
    on: {
      "openErrorTip": _vm.openErrorTip
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56ba6005"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/new-invite/Start.vue
// module id = 726
// module chunks = 1